<template>
  <div id="app" :class="[$i18n.locale, 'normal', theme]">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  created() {
    document.body.onkeydown = function (e) {
      // 禁止f11全屏
      e.keyCode === 122 && e.preventDefault();
    };
  },
  computed: {
    ...mapState('app', ['theme', 'themeList'])
  },
  mounted() {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener(
      'hashchange',
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  },
  watch: {
    theme: {
      handler() {
        this.themeList.forEach(e => {
          document.body.classList.remove(e);
        });
        document.body.classList.add(this.theme);
      },
      immediate: true
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import '@/assets/css/index.scss';

#app {
  height: 100vh;
}
</style>
